export default __webpack_public_path__ + "banner-framework2fb66da.png";